import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import Link from "next/link";
import styles from "./contact-email.module.scss";
import getEmailUsUrl from "@/utils/getEmailUsUrl";

const unavailableEmailOption = () => (
  <div>
    <br />
    <p>
      <strong>Currently unavailable</strong>
    </p>
    <p>You can still get in touch by calling our Customer Service team.</p>
  </div>
);

const availableEmailOption = location => (
  <>
    <p>
      Please note: if you prefer to <Link href={getEmailUsUrl(location)}>email us</Link>, it may take up to 24 hours for
      a response and longer for us to resolve your query.
    </p>
    <p>We recommend phone for a quicker response and resolution.</p>
  </>
);

function ContactEmail({ className, config: { open }, location }) {
  return (
    <div className={classnames(className, styles["contact-email"])} data-test="container-email">
      <h4 className={styles["contact-email__title"]}>Email</h4>
      {open ? availableEmailOption(location) : unavailableEmailOption()}
    </div>
  );
}

ContactEmail.propTypes = {
  config: PropTypes.shape({
    open: PropTypes.bool,
  }).isRequired,
  className: PropTypes.string,
  location: PropTypes.string,
};

ContactEmail.defaultProps = {
  className: undefined,
  location: undefined,
};

export default ContactEmail;
